// extracted by mini-css-extract-plugin
module.exports = {"shadow":"ChatAvatars_shadow__aOscA"};